// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: chat_session.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AnalysisTreeProto } from "./analysis";
import { AnalysisPlanProto, KGObservationProto } from "./analysis_plan";
import { AnalystProto, ScenarioAnalysis } from "./analyst";
import {
  ArtifactType,
  artifactTypeFromJSON,
  artifactTypeToJSON,
  ChatMessageType,
  chatMessageTypeFromJSON,
  chatMessageTypeToJSON,
  DarwinAgentType,
  darwinAgentTypeFromJSON,
  darwinAgentTypeToJSON,
  DarwinHeader,
  ExecutionStatusType,
  executionStatusTypeFromJSON,
  executionStatusTypeToJSON,
} from "./common";
import { CustomAgentProto } from "./custom_agent";
import {
  ArgsSchemaType,
  argsSchemaTypeFromJSON,
  argsSchemaTypeToJSON,
  DarwinToolType,
  darwinToolTypeFromJSON,
  darwinToolTypeToJSON,
} from "./darwin_agent";
import { DataFrameAnalysisProto, FileArtifactProto, KGDataFrameProto } from "./dataframe";
import { Header } from "./metadata";
import { ScheduledJobProto } from "./schedule";

export const protobufPackage = "com.anko.darwin";

/** Client types */
export enum ChatClientType {
  UNKNOWN_CLIENT_TYPE = 0,
  EVA = 1,
  FRIDA = 2,
  SLACK = 3,
  SCHEDULED = 4,
  UNRECOGNIZED = -1,
}

export function chatClientTypeFromJSON(object: any): ChatClientType {
  switch (object) {
    case 0:
    case "UNKNOWN_CLIENT_TYPE":
      return ChatClientType.UNKNOWN_CLIENT_TYPE;
    case 1:
    case "EVA":
      return ChatClientType.EVA;
    case 2:
    case "FRIDA":
      return ChatClientType.FRIDA;
    case 3:
    case "SLACK":
      return ChatClientType.SLACK;
    case 4:
    case "SCHEDULED":
      return ChatClientType.SCHEDULED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChatClientType.UNRECOGNIZED;
  }
}

export function chatClientTypeToJSON(object: ChatClientType): string {
  switch (object) {
    case ChatClientType.UNKNOWN_CLIENT_TYPE:
      return "UNKNOWN_CLIENT_TYPE";
    case ChatClientType.EVA:
      return "EVA";
    case ChatClientType.FRIDA:
      return "FRIDA";
    case ChatClientType.SLACK:
      return "SLACK";
    case ChatClientType.SCHEDULED:
      return "SCHEDULED";
    case ChatClientType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Scenario agent response output */
export interface ScenarioOutput {
  /** Status of the scenario execution */
  status?:
    | ScenarioOutput_ScenarioStatus
    | undefined;
  /** Findings from the scenario execution */
  findings?:
    | string
    | undefined;
  /** Dataframes referenced */
  kg_dataframes: KGDataFrameProto[];
}

/** Status for scenario execution */
export enum ScenarioOutput_ScenarioStatus {
  INVALID = 0,
  VALID = 1,
  WARNING = 2,
  ERROR = 3,
  UNRECOGNIZED = -1,
}

export function scenarioOutput_ScenarioStatusFromJSON(object: any): ScenarioOutput_ScenarioStatus {
  switch (object) {
    case 0:
    case "INVALID":
      return ScenarioOutput_ScenarioStatus.INVALID;
    case 1:
    case "VALID":
      return ScenarioOutput_ScenarioStatus.VALID;
    case 2:
    case "WARNING":
      return ScenarioOutput_ScenarioStatus.WARNING;
    case 3:
    case "ERROR":
      return ScenarioOutput_ScenarioStatus.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScenarioOutput_ScenarioStatus.UNRECOGNIZED;
  }
}

export function scenarioOutput_ScenarioStatusToJSON(object: ScenarioOutput_ScenarioStatus): string {
  switch (object) {
    case ScenarioOutput_ScenarioStatus.INVALID:
      return "INVALID";
    case ScenarioOutput_ScenarioStatus.VALID:
      return "VALID";
    case ScenarioOutput_ScenarioStatus.WARNING:
      return "WARNING";
    case ScenarioOutput_ScenarioStatus.ERROR:
      return "ERROR";
    case ScenarioOutput_ScenarioStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Scenario synthesis agent response output */
export interface NotificationOutput {
  /** Output string from synthesis */
  output_string?:
    | string
    | undefined;
  /** Whether to notify the user */
  notify?:
    | boolean
    | undefined;
  /** Reason for the notify decision */
  notify_reason?: string | undefined;
}

/** Wrapper for response tool outputs - used in ChatMessageProto for RESPONSE type messages */
export interface ResponseMessageProto {
  type?: ArgsSchemaType | undefined;
  scenario_output?: ScenarioOutput | undefined;
  scenario_synthesis_output?: NotificationOutput | undefined;
}

/** Analyst job run proto — self-contained representation of a completed job run */
export interface AnalystJobRunProto {
  /** Header (id, name, etc.) */
  header?:
    | Header
    | undefined;
  /** Scenario outputs */
  scenario_outputs: AnalystJobRunProto_ScenarioOutputEntry[];
  /** Synthesis / notification output */
  synthesis_output?: NotificationOutput | undefined;
}

/** Scenario output with its scenario ID */
export interface AnalystJobRunProto_ScenarioOutputEntry {
  scenario_id?: string | undefined;
  scenario_output?: ScenarioOutput | undefined;
}

/** Search result artifact produced by the workflow run search tool */
export interface WorkflowRunSearchProto {
  /** Header of this search result artifact */
  header?:
    | DarwinHeader
    | undefined;
  /** Id of the job whose runs were searched */
  job_id?:
    | string
    | undefined;
  /** Maximum number of runs requested */
  last_n?:
    | number
    | undefined;
  /** Optional date range start */
  start_time?:
    | number
    | undefined;
  /** Optional date range end */
  end_time?:
    | number
    | undefined;
  /** Lightweight info rows for each matching workflow run */
  workflow_runs: WorkflowRunProto[];
}

/** Workflow run artifact produced by a workflow run */
export interface WorkflowRunProto {
  /** Header of the workflow run (description holds the short run label) */
  header?:
    | DarwinHeader
    | undefined;
  /** Key findings from the workflow run */
  findings?:
    | string
    | undefined;
  /** Id of the job that triggered this workflow run */
  job_id?:
    | string
    | undefined;
  /** chat id */
  source_chat_id?:
    | string
    | undefined;
  /** Artifacts consumed by the workflow */
  input_artifacts: ArtifactProto[];
  /** Artifacts produced by the workflow */
  output_artifacts: ArtifactProto[];
  /** Run-level errors (e.g. missing nested artifacts, load failures) */
  errors: string[];
}

/** Analysis output artifact produced by SaveAnalysisOutputToolSchema */
export interface AnalysisOutputProto {
  /** Header of the analysis output. */
  header?:
    | DarwinHeader
    | undefined;
  /** Key findings from the analysis run */
  findings?:
    | string
    | undefined;
  /** Id of the analysis (ScheduleJob) this output belongs to */
  job_id?: string | undefined;
}

/** Artifact: metadata about accessed resources */
export interface ArtifactProto {
  /** Artifact Type */
  artifact_type?:
    | ArtifactType
    | undefined;
  /** kg_observation structure for artifact */
  kg_observation?:
    | KGObservationProto
    | undefined;
  /** kg_dataframe structure for artifact */
  kg_dataframe?:
    | KGDataFrameProto
    | undefined;
  /** scenario structure for artifact */
  scenario?:
    | ScenarioAnalysis
    | undefined;
  /** analyst_job_run structure for artifact */
  analyst_job_run?:
    | AnalystJobRunProto
    | undefined;
  /** scenario_job structure for artifact */
  scenario_job?:
    | ScheduledJobProto
    | undefined;
  /** Tool that produced or last touched this artifact */
  tool_type?:
    | DarwinToolType
    | undefined;
  /** analysis output artifact for scheduled scenario runs */
  analysis_output?:
    | AnalysisOutputProto
    | undefined;
  /** chat session Id */
  chat_id?:
    | string
    | undefined;
  /** derived_dataframe structure for artifact */
  dataframe_analysis?:
    | DataFrameAnalysisProto
    | undefined;
  /** file_artifact structure for uploaded files — Darwin-internal, not rendered in Frida */
  file_artifact?:
    | FileArtifactProto
    | undefined;
  /** workflow run artifact */
  workflow_run?:
    | WorkflowRunProto
    | undefined;
  /** workflow run search result artifact */
  workflow_run_search?: WorkflowRunSearchProto | undefined;
}

export interface ChatMessageProto {
  /** Message type */
  message_type?:
    | ChatMessageType
    | undefined;
  /** Content for simple messages (SYSTEM, HUMAN, RESPONSE) */
  content?:
    | string
    | undefined;
  /** For REASONING type: embedded child conversation as JSON strings */
  langgraph_message_json_list: string[];
  /**
   * Artifacts: map of index -> Artifact (relative to base_messages)
   * TODO: Map the artifacts to the index in langgraph message array.
   */
  artifacts: ArtifactProto[];
  /** For RESPONSE type: structured response from response tools */
  response_message?:
    | ResponseMessageProto
    | undefined;
  /** LangSmith url for this AI response */
  ls_trace_url?:
    | string
    | undefined;
  /** Unique identifier for this message */
  id?:
    | string
    | undefined;
  /** Timestamp in epoch milliseconds (created on init, updated on append for REASONING) */
  timestamp_ms?: number | undefined;
  execution_steps: ExecutionStepProto[];
}

/** This is the master proto for inputs of all agents. */
export interface AgentInputProto {
  trees: AnalysisTreeProto[];
  plans: AnalysisPlanProto[];
  custom_agents: CustomAgentProto[];
  analyst?: AnalystProto | undefined;
  scheduled_job?:
    | ScheduledJobProto
    | undefined;
  /** Override jinja variables for Eva Playground */
  override_jinja_variables?: AgentInputProto_OverrideVariables | undefined;
  scenario_jobs: ScheduledJobProto[];
}

/** Override jinja variables, these are only set by Eva playground */
export interface AgentInputProto_OverrideVariables {
  /**
   * Date override for prompt templates default: current system datetime
   * Date format: %Y-%m-%d
   */
  today_date?:
    | string
    | undefined;
  /** variable to override company name default value comes from env */
  company_name?:
    | string
    | undefined;
  /** variable to set week start day default should be Monday */
  week_start_day?:
    | string
    | undefined;
  /** variable to set quarter start month default should be January */
  quarter_start_month?: string | undefined;
}

export interface ChatResponse {
  /** Session header containing session_id, name, and client_type (in type field) */
  session_header?:
    | DarwinHeader
    | undefined;
  /** Chat messages */
  messages: ChatMessageProto[];
  /** Execution status of the session */
  status?:
    | ExecutionStatusType
    | undefined;
  /** Analyst id associated with this chat session, derived from associated_entity_keys */
  analyst_id?: string | undefined;
}

/** Wrapper for chat initialization configuration */
export interface ChatContext {
  /** Agent type */
  agent_type?:
    | DarwinAgentType
    | undefined;
  /** Agent header */
  agent_header?:
    | DarwinHeader
    | undefined;
  /** Prompt header */
  prompt_header?:
    | DarwinHeader
    | undefined;
  /** Agent input */
  agent_input?: AgentInputProto | undefined;
}

/** A single uploaded file attached to a chat request */
export interface UploadedFile {
  /** Raw bytes of the file (base64-encoded in JSON transport) */
  file_bytes?:
    | Uint8Array
    | undefined;
  /** Original client filename, e.g. "sales.csv" */
  file_name?: string | undefined;
}

/**
 * Request to parse raw pasted tabular text (from Excel, Google Sheets, or CSV)
 * into a structured preview before uploading it as a CSV file artifact.
 */
export interface ParseTableRequest {
  /** Raw pasted text — tab-separated, comma-separated, semicolon-separated, or any RFC 4180 CSV */
  raw_text?: string | undefined;
}

/** A single row in the table preview returned by ParseTableResponse */
export interface ParsedTablePreviewRow {
  cells: string[];
}

/**
 * Response from the parse_table endpoint — carries enough information for Frida
 * to render the column/type preview and then re-submit the csv_string as a file upload.
 */
export interface ParseTableResponse {
  /** True if parsing succeeded; false if the text could not be interpreted as a table */
  success?:
    | boolean
    | undefined;
  /** Human-readable error message when success is false */
  error_message?:
    | string
    | undefined;
  /** Column header names in order */
  headers: string[];
  /**
   * Inferred type label per column in the same order as headers
   * Values: "Number", "Text", "Date", "Boolean"
   */
  column_types: string[];
  /** Total number of data rows (excluding the header row) */
  row_count?:
    | number
    | undefined;
  /** First up to 5 data rows for UI preview */
  preview_rows: ParsedTablePreviewRow[];
  /** Full RFC 4180 CSV string ready to be wrapped in a File object by Frida */
  csv_string?: string | undefined;
}

/** Chat request message for starting/continuing conversations */
export interface ChatRequest {
  /** Session header containing session_id and client_type (in type field) */
  session_header?:
    | DarwinHeader
    | undefined;
  /**
   * Initialization config
   * Required for START (when session_header.id is not present)
   * Ignored for CONTINUE (when session_header.id is present)
   */
  chat_context?:
    | ChatContext
    | undefined;
  /**
   * User message
   * When provided with ChatContext (START): triggers agent execution
   * When provided with session_header.id (CONTINUE): continues the conversation.
   */
  message?:
    | string
    | undefined;
  /** If true, automatically saves new messages to database after execution */
  is_save?:
    | boolean
    | undefined;
  /** If true, the server returns a streaming SSE response instead of a full JSON response */
  stream_response?:
    | boolean
    | undefined;
  /** One or more files uploaded with this chat request */
  uploaded_files: UploadedFile[];
}

export interface ExecutionStepProto {
  /** status of execution step */
  status?:
    | ExecutionStatusType
    | undefined;
  /** type of tool */
  tool_type?:
    | DarwinToolType
    | undefined;
  /** timestamp in ms */
  timestamp_ms?:
    | number
    | undefined;
  /** artifacts (if present) generated in this execution step */
  artifacts: ArtifactProto[];
  /** labels used for UI display */
  step_labels: string[];
  /** error message, populated on TOOL_CALL_FAILURE steps */
  error?:
    | string
    | undefined;
  /** reasoning summary */
  reasoning_summary?: string | undefined;
}

export interface StreamResponseProto {
  type?: StreamResponseProto_StremResponseType | undefined;
  text?: string | undefined;
  index?: number | undefined;
  step?: ExecutionStepProto | undefined;
}

export enum StreamResponseProto_StremResponseType {
  UNKNOWN_STREAM_RESPONSE_TYPE = 0,
  REASONING = 1,
  RESPONSE = 2,
  EXECUTION_STEP = 3,
  UNRECOGNIZED = -1,
}

export function streamResponseProto_StremResponseTypeFromJSON(object: any): StreamResponseProto_StremResponseType {
  switch (object) {
    case 0:
    case "UNKNOWN_STREAM_RESPONSE_TYPE":
      return StreamResponseProto_StremResponseType.UNKNOWN_STREAM_RESPONSE_TYPE;
    case 1:
    case "REASONING":
      return StreamResponseProto_StremResponseType.REASONING;
    case 2:
    case "RESPONSE":
      return StreamResponseProto_StremResponseType.RESPONSE;
    case 3:
    case "EXECUTION_STEP":
      return StreamResponseProto_StremResponseType.EXECUTION_STEP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StreamResponseProto_StremResponseType.UNRECOGNIZED;
  }
}

export function streamResponseProto_StremResponseTypeToJSON(object: StreamResponseProto_StremResponseType): string {
  switch (object) {
    case StreamResponseProto_StremResponseType.UNKNOWN_STREAM_RESPONSE_TYPE:
      return "UNKNOWN_STREAM_RESPONSE_TYPE";
    case StreamResponseProto_StremResponseType.REASONING:
      return "REASONING";
    case StreamResponseProto_StremResponseType.RESPONSE:
      return "RESPONSE";
    case StreamResponseProto_StremResponseType.EXECUTION_STEP:
      return "EXECUTION_STEP";
    case StreamResponseProto_StremResponseType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseScenarioOutput(): ScenarioOutput {
  return { status: undefined, findings: undefined, kg_dataframes: [] };
}

export const ScenarioOutput: MessageFns<ScenarioOutput> = {
  encode(message: ScenarioOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== undefined) {
      writer.uint32(8).int32(message.status);
    }
    if (message.findings !== undefined) {
      writer.uint32(18).string(message.findings);
    }
    for (const v of message.kg_dataframes) {
      KGDataFrameProto.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenarioOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.findings = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.kg_dataframes.push(KGDataFrameProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenarioOutput {
    return {
      status: isSet(object.status) ? scenarioOutput_ScenarioStatusFromJSON(object.status) : undefined,
      findings: isSet(object.findings) ? globalThis.String(object.findings) : undefined,
      kg_dataframes: globalThis.Array.isArray(object?.kg_dataframes)
        ? object.kg_dataframes.map((e: any) => KGDataFrameProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScenarioOutput): unknown {
    const obj: any = {};
    if (message.status !== undefined) {
      obj.status = scenarioOutput_ScenarioStatusToJSON(message.status);
    }
    if (message.findings !== undefined) {
      obj.findings = message.findings;
    }
    if (message.kg_dataframes?.length) {
      obj.kg_dataframes = message.kg_dataframes.map((e) => KGDataFrameProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioOutput>, I>>(base?: I): ScenarioOutput {
    return ScenarioOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioOutput>, I>>(object: I): ScenarioOutput {
    const message = createBaseScenarioOutput();
    message.status = object.status ?? undefined;
    message.findings = object.findings ?? undefined;
    message.kg_dataframes = object.kg_dataframes?.map((e) => KGDataFrameProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNotificationOutput(): NotificationOutput {
  return { output_string: undefined, notify: undefined, notify_reason: undefined };
}

export const NotificationOutput: MessageFns<NotificationOutput> = {
  encode(message: NotificationOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.output_string !== undefined) {
      writer.uint32(10).string(message.output_string);
    }
    if (message.notify !== undefined) {
      writer.uint32(16).bool(message.notify);
    }
    if (message.notify_reason !== undefined) {
      writer.uint32(26).string(message.notify_reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotificationOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotificationOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.output_string = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.notify = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.notify_reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotificationOutput {
    return {
      output_string: isSet(object.output_string) ? globalThis.String(object.output_string) : undefined,
      notify: isSet(object.notify) ? globalThis.Boolean(object.notify) : undefined,
      notify_reason: isSet(object.notify_reason) ? globalThis.String(object.notify_reason) : undefined,
    };
  },

  toJSON(message: NotificationOutput): unknown {
    const obj: any = {};
    if (message.output_string !== undefined) {
      obj.output_string = message.output_string;
    }
    if (message.notify !== undefined) {
      obj.notify = message.notify;
    }
    if (message.notify_reason !== undefined) {
      obj.notify_reason = message.notify_reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NotificationOutput>, I>>(base?: I): NotificationOutput {
    return NotificationOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NotificationOutput>, I>>(object: I): NotificationOutput {
    const message = createBaseNotificationOutput();
    message.output_string = object.output_string ?? undefined;
    message.notify = object.notify ?? undefined;
    message.notify_reason = object.notify_reason ?? undefined;
    return message;
  },
};

function createBaseResponseMessageProto(): ResponseMessageProto {
  return { type: undefined, scenario_output: undefined, scenario_synthesis_output: undefined };
}

export const ResponseMessageProto: MessageFns<ResponseMessageProto> = {
  encode(message: ResponseMessageProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.scenario_output !== undefined) {
      ScenarioOutput.encode(message.scenario_output, writer.uint32(18).fork()).join();
    }
    if (message.scenario_synthesis_output !== undefined) {
      NotificationOutput.encode(message.scenario_synthesis_output, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResponseMessageProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseMessageProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scenario_output = ScenarioOutput.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scenario_synthesis_output = NotificationOutput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResponseMessageProto {
    return {
      type: isSet(object.type) ? argsSchemaTypeFromJSON(object.type) : undefined,
      scenario_output: isSet(object.scenario_output) ? ScenarioOutput.fromJSON(object.scenario_output) : undefined,
      scenario_synthesis_output: isSet(object.scenario_synthesis_output)
        ? NotificationOutput.fromJSON(object.scenario_synthesis_output)
        : undefined,
    };
  },

  toJSON(message: ResponseMessageProto): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = argsSchemaTypeToJSON(message.type);
    }
    if (message.scenario_output !== undefined) {
      obj.scenario_output = ScenarioOutput.toJSON(message.scenario_output);
    }
    if (message.scenario_synthesis_output !== undefined) {
      obj.scenario_synthesis_output = NotificationOutput.toJSON(message.scenario_synthesis_output);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResponseMessageProto>, I>>(base?: I): ResponseMessageProto {
    return ResponseMessageProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResponseMessageProto>, I>>(object: I): ResponseMessageProto {
    const message = createBaseResponseMessageProto();
    message.type = object.type ?? undefined;
    message.scenario_output = (object.scenario_output !== undefined && object.scenario_output !== null)
      ? ScenarioOutput.fromPartial(object.scenario_output)
      : undefined;
    message.scenario_synthesis_output =
      (object.scenario_synthesis_output !== undefined && object.scenario_synthesis_output !== null)
        ? NotificationOutput.fromPartial(object.scenario_synthesis_output)
        : undefined;
    return message;
  },
};

function createBaseAnalystJobRunProto(): AnalystJobRunProto {
  return { header: undefined, scenario_outputs: [], synthesis_output: undefined };
}

export const AnalystJobRunProto: MessageFns<AnalystJobRunProto> = {
  encode(message: AnalystJobRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.scenario_outputs) {
      AnalystJobRunProto_ScenarioOutputEntry.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.synthesis_output !== undefined) {
      NotificationOutput.encode(message.synthesis_output, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalystJobRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalystJobRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scenario_outputs.push(AnalystJobRunProto_ScenarioOutputEntry.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.synthesis_output = NotificationOutput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalystJobRunProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      scenario_outputs: globalThis.Array.isArray(object?.scenario_outputs)
        ? object.scenario_outputs.map((e: any) => AnalystJobRunProto_ScenarioOutputEntry.fromJSON(e))
        : [],
      synthesis_output: isSet(object.synthesis_output)
        ? NotificationOutput.fromJSON(object.synthesis_output)
        : undefined,
    };
  },

  toJSON(message: AnalystJobRunProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.scenario_outputs?.length) {
      obj.scenario_outputs = message.scenario_outputs.map((e) => AnalystJobRunProto_ScenarioOutputEntry.toJSON(e));
    }
    if (message.synthesis_output !== undefined) {
      obj.synthesis_output = NotificationOutput.toJSON(message.synthesis_output);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalystJobRunProto>, I>>(base?: I): AnalystJobRunProto {
    return AnalystJobRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalystJobRunProto>, I>>(object: I): AnalystJobRunProto {
    const message = createBaseAnalystJobRunProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.scenario_outputs =
      object.scenario_outputs?.map((e) => AnalystJobRunProto_ScenarioOutputEntry.fromPartial(e)) || [];
    message.synthesis_output = (object.synthesis_output !== undefined && object.synthesis_output !== null)
      ? NotificationOutput.fromPartial(object.synthesis_output)
      : undefined;
    return message;
  },
};

function createBaseAnalystJobRunProto_ScenarioOutputEntry(): AnalystJobRunProto_ScenarioOutputEntry {
  return { scenario_id: undefined, scenario_output: undefined };
}

export const AnalystJobRunProto_ScenarioOutputEntry: MessageFns<AnalystJobRunProto_ScenarioOutputEntry> = {
  encode(message: AnalystJobRunProto_ScenarioOutputEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scenario_id !== undefined) {
      writer.uint32(10).string(message.scenario_id);
    }
    if (message.scenario_output !== undefined) {
      ScenarioOutput.encode(message.scenario_output, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalystJobRunProto_ScenarioOutputEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalystJobRunProto_ScenarioOutputEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.scenario_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scenario_output = ScenarioOutput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalystJobRunProto_ScenarioOutputEntry {
    return {
      scenario_id: isSet(object.scenario_id) ? globalThis.String(object.scenario_id) : undefined,
      scenario_output: isSet(object.scenario_output) ? ScenarioOutput.fromJSON(object.scenario_output) : undefined,
    };
  },

  toJSON(message: AnalystJobRunProto_ScenarioOutputEntry): unknown {
    const obj: any = {};
    if (message.scenario_id !== undefined) {
      obj.scenario_id = message.scenario_id;
    }
    if (message.scenario_output !== undefined) {
      obj.scenario_output = ScenarioOutput.toJSON(message.scenario_output);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalystJobRunProto_ScenarioOutputEntry>, I>>(
    base?: I,
  ): AnalystJobRunProto_ScenarioOutputEntry {
    return AnalystJobRunProto_ScenarioOutputEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalystJobRunProto_ScenarioOutputEntry>, I>>(
    object: I,
  ): AnalystJobRunProto_ScenarioOutputEntry {
    const message = createBaseAnalystJobRunProto_ScenarioOutputEntry();
    message.scenario_id = object.scenario_id ?? undefined;
    message.scenario_output = (object.scenario_output !== undefined && object.scenario_output !== null)
      ? ScenarioOutput.fromPartial(object.scenario_output)
      : undefined;
    return message;
  },
};

function createBaseWorkflowRunSearchProto(): WorkflowRunSearchProto {
  return {
    header: undefined,
    job_id: undefined,
    last_n: undefined,
    start_time: undefined,
    end_time: undefined,
    workflow_runs: [],
  };
}

export const WorkflowRunSearchProto: MessageFns<WorkflowRunSearchProto> = {
  encode(message: WorkflowRunSearchProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.job_id !== undefined) {
      writer.uint32(18).string(message.job_id);
    }
    if (message.last_n !== undefined) {
      writer.uint32(24).int32(message.last_n);
    }
    if (message.start_time !== undefined) {
      writer.uint32(32).int64(message.start_time);
    }
    if (message.end_time !== undefined) {
      writer.uint32(40).int64(message.end_time);
    }
    for (const v of message.workflow_runs) {
      WorkflowRunProto.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkflowRunSearchProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkflowRunSearchProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.job_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.last_n = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.start_time = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.end_time = longToNumber(reader.int64());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.workflow_runs.push(WorkflowRunProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkflowRunSearchProto {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      job_id: isSet(object.job_id) ? globalThis.String(object.job_id) : undefined,
      last_n: isSet(object.last_n) ? globalThis.Number(object.last_n) : undefined,
      start_time: isSet(object.start_time) ? globalThis.Number(object.start_time) : undefined,
      end_time: isSet(object.end_time) ? globalThis.Number(object.end_time) : undefined,
      workflow_runs: globalThis.Array.isArray(object?.workflow_runs)
        ? object.workflow_runs.map((e: any) => WorkflowRunProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WorkflowRunSearchProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.job_id !== undefined) {
      obj.job_id = message.job_id;
    }
    if (message.last_n !== undefined) {
      obj.last_n = Math.round(message.last_n);
    }
    if (message.start_time !== undefined) {
      obj.start_time = Math.round(message.start_time);
    }
    if (message.end_time !== undefined) {
      obj.end_time = Math.round(message.end_time);
    }
    if (message.workflow_runs?.length) {
      obj.workflow_runs = message.workflow_runs.map((e) => WorkflowRunProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorkflowRunSearchProto>, I>>(base?: I): WorkflowRunSearchProto {
    return WorkflowRunSearchProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorkflowRunSearchProto>, I>>(object: I): WorkflowRunSearchProto {
    const message = createBaseWorkflowRunSearchProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.job_id = object.job_id ?? undefined;
    message.last_n = object.last_n ?? undefined;
    message.start_time = object.start_time ?? undefined;
    message.end_time = object.end_time ?? undefined;
    message.workflow_runs = object.workflow_runs?.map((e) => WorkflowRunProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWorkflowRunProto(): WorkflowRunProto {
  return {
    header: undefined,
    findings: undefined,
    job_id: undefined,
    source_chat_id: undefined,
    input_artifacts: [],
    output_artifacts: [],
    errors: [],
  };
}

export const WorkflowRunProto: MessageFns<WorkflowRunProto> = {
  encode(message: WorkflowRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.findings !== undefined) {
      writer.uint32(18).string(message.findings);
    }
    if (message.job_id !== undefined) {
      writer.uint32(26).string(message.job_id);
    }
    if (message.source_chat_id !== undefined) {
      writer.uint32(34).string(message.source_chat_id);
    }
    for (const v of message.input_artifacts) {
      ArtifactProto.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.output_artifacts) {
      ArtifactProto.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.errors) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkflowRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkflowRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.findings = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.job_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.source_chat_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.input_artifacts.push(ArtifactProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.output_artifacts.push(ArtifactProto.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.errors.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkflowRunProto {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      findings: isSet(object.findings) ? globalThis.String(object.findings) : undefined,
      job_id: isSet(object.job_id) ? globalThis.String(object.job_id) : undefined,
      source_chat_id: isSet(object.source_chat_id) ? globalThis.String(object.source_chat_id) : undefined,
      input_artifacts: globalThis.Array.isArray(object?.input_artifacts)
        ? object.input_artifacts.map((e: any) => ArtifactProto.fromJSON(e))
        : [],
      output_artifacts: globalThis.Array.isArray(object?.output_artifacts)
        ? object.output_artifacts.map((e: any) => ArtifactProto.fromJSON(e))
        : [],
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: WorkflowRunProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.findings !== undefined) {
      obj.findings = message.findings;
    }
    if (message.job_id !== undefined) {
      obj.job_id = message.job_id;
    }
    if (message.source_chat_id !== undefined) {
      obj.source_chat_id = message.source_chat_id;
    }
    if (message.input_artifacts?.length) {
      obj.input_artifacts = message.input_artifacts.map((e) => ArtifactProto.toJSON(e));
    }
    if (message.output_artifacts?.length) {
      obj.output_artifacts = message.output_artifacts.map((e) => ArtifactProto.toJSON(e));
    }
    if (message.errors?.length) {
      obj.errors = message.errors;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorkflowRunProto>, I>>(base?: I): WorkflowRunProto {
    return WorkflowRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorkflowRunProto>, I>>(object: I): WorkflowRunProto {
    const message = createBaseWorkflowRunProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.findings = object.findings ?? undefined;
    message.job_id = object.job_id ?? undefined;
    message.source_chat_id = object.source_chat_id ?? undefined;
    message.input_artifacts = object.input_artifacts?.map((e) => ArtifactProto.fromPartial(e)) || [];
    message.output_artifacts = object.output_artifacts?.map((e) => ArtifactProto.fromPartial(e)) || [];
    message.errors = object.errors?.map((e) => e) || [];
    return message;
  },
};

function createBaseAnalysisOutputProto(): AnalysisOutputProto {
  return { header: undefined, findings: undefined, job_id: undefined };
}

export const AnalysisOutputProto: MessageFns<AnalysisOutputProto> = {
  encode(message: AnalysisOutputProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.findings !== undefined) {
      writer.uint32(18).string(message.findings);
    }
    if (message.job_id !== undefined) {
      writer.uint32(26).string(message.job_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisOutputProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisOutputProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.findings = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.job_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisOutputProto {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      findings: isSet(object.findings) ? globalThis.String(object.findings) : undefined,
      job_id: isSet(object.job_id) ? globalThis.String(object.job_id) : undefined,
    };
  },

  toJSON(message: AnalysisOutputProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.findings !== undefined) {
      obj.findings = message.findings;
    }
    if (message.job_id !== undefined) {
      obj.job_id = message.job_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisOutputProto>, I>>(base?: I): AnalysisOutputProto {
    return AnalysisOutputProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisOutputProto>, I>>(object: I): AnalysisOutputProto {
    const message = createBaseAnalysisOutputProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.findings = object.findings ?? undefined;
    message.job_id = object.job_id ?? undefined;
    return message;
  },
};

function createBaseArtifactProto(): ArtifactProto {
  return {
    artifact_type: undefined,
    kg_observation: undefined,
    kg_dataframe: undefined,
    scenario: undefined,
    analyst_job_run: undefined,
    scenario_job: undefined,
    tool_type: undefined,
    analysis_output: undefined,
    chat_id: undefined,
    dataframe_analysis: undefined,
    file_artifact: undefined,
    workflow_run: undefined,
    workflow_run_search: undefined,
  };
}

export const ArtifactProto: MessageFns<ArtifactProto> = {
  encode(message: ArtifactProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.artifact_type !== undefined) {
      writer.uint32(8).int32(message.artifact_type);
    }
    if (message.kg_observation !== undefined) {
      KGObservationProto.encode(message.kg_observation, writer.uint32(18).fork()).join();
    }
    if (message.kg_dataframe !== undefined) {
      KGDataFrameProto.encode(message.kg_dataframe, writer.uint32(26).fork()).join();
    }
    if (message.scenario !== undefined) {
      ScenarioAnalysis.encode(message.scenario, writer.uint32(34).fork()).join();
    }
    if (message.analyst_job_run !== undefined) {
      AnalystJobRunProto.encode(message.analyst_job_run, writer.uint32(42).fork()).join();
    }
    if (message.scenario_job !== undefined) {
      ScheduledJobProto.encode(message.scenario_job, writer.uint32(50).fork()).join();
    }
    if (message.tool_type !== undefined) {
      writer.uint32(56).int32(message.tool_type);
    }
    if (message.analysis_output !== undefined) {
      AnalysisOutputProto.encode(message.analysis_output, writer.uint32(66).fork()).join();
    }
    if (message.chat_id !== undefined) {
      writer.uint32(74).string(message.chat_id);
    }
    if (message.dataframe_analysis !== undefined) {
      DataFrameAnalysisProto.encode(message.dataframe_analysis, writer.uint32(82).fork()).join();
    }
    if (message.file_artifact !== undefined) {
      FileArtifactProto.encode(message.file_artifact, writer.uint32(90).fork()).join();
    }
    if (message.workflow_run !== undefined) {
      WorkflowRunProto.encode(message.workflow_run, writer.uint32(98).fork()).join();
    }
    if (message.workflow_run_search !== undefined) {
      WorkflowRunSearchProto.encode(message.workflow_run_search, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.artifact_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.kg_dataframe = KGDataFrameProto.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.scenario = ScenarioAnalysis.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.analyst_job_run = AnalystJobRunProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.scenario_job = ScheduledJobProto.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.tool_type = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.analysis_output = AnalysisOutputProto.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.chat_id = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.dataframe_analysis = DataFrameAnalysisProto.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.file_artifact = FileArtifactProto.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.workflow_run = WorkflowRunProto.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.workflow_run_search = WorkflowRunSearchProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactProto {
    return {
      artifact_type: isSet(object.artifact_type) ? artifactTypeFromJSON(object.artifact_type) : undefined,
      kg_observation: isSet(object.kg_observation) ? KGObservationProto.fromJSON(object.kg_observation) : undefined,
      kg_dataframe: isSet(object.kg_dataframe) ? KGDataFrameProto.fromJSON(object.kg_dataframe) : undefined,
      scenario: isSet(object.scenario) ? ScenarioAnalysis.fromJSON(object.scenario) : undefined,
      analyst_job_run: isSet(object.analyst_job_run) ? AnalystJobRunProto.fromJSON(object.analyst_job_run) : undefined,
      scenario_job: isSet(object.scenario_job) ? ScheduledJobProto.fromJSON(object.scenario_job) : undefined,
      tool_type: isSet(object.tool_type) ? darwinToolTypeFromJSON(object.tool_type) : undefined,
      analysis_output: isSet(object.analysis_output) ? AnalysisOutputProto.fromJSON(object.analysis_output) : undefined,
      chat_id: isSet(object.chat_id) ? globalThis.String(object.chat_id) : undefined,
      dataframe_analysis: isSet(object.dataframe_analysis)
        ? DataFrameAnalysisProto.fromJSON(object.dataframe_analysis)
        : undefined,
      file_artifact: isSet(object.file_artifact) ? FileArtifactProto.fromJSON(object.file_artifact) : undefined,
      workflow_run: isSet(object.workflow_run) ? WorkflowRunProto.fromJSON(object.workflow_run) : undefined,
      workflow_run_search: isSet(object.workflow_run_search)
        ? WorkflowRunSearchProto.fromJSON(object.workflow_run_search)
        : undefined,
    };
  },

  toJSON(message: ArtifactProto): unknown {
    const obj: any = {};
    if (message.artifact_type !== undefined) {
      obj.artifact_type = artifactTypeToJSON(message.artifact_type);
    }
    if (message.kg_observation !== undefined) {
      obj.kg_observation = KGObservationProto.toJSON(message.kg_observation);
    }
    if (message.kg_dataframe !== undefined) {
      obj.kg_dataframe = KGDataFrameProto.toJSON(message.kg_dataframe);
    }
    if (message.scenario !== undefined) {
      obj.scenario = ScenarioAnalysis.toJSON(message.scenario);
    }
    if (message.analyst_job_run !== undefined) {
      obj.analyst_job_run = AnalystJobRunProto.toJSON(message.analyst_job_run);
    }
    if (message.scenario_job !== undefined) {
      obj.scenario_job = ScheduledJobProto.toJSON(message.scenario_job);
    }
    if (message.tool_type !== undefined) {
      obj.tool_type = darwinToolTypeToJSON(message.tool_type);
    }
    if (message.analysis_output !== undefined) {
      obj.analysis_output = AnalysisOutputProto.toJSON(message.analysis_output);
    }
    if (message.chat_id !== undefined) {
      obj.chat_id = message.chat_id;
    }
    if (message.dataframe_analysis !== undefined) {
      obj.dataframe_analysis = DataFrameAnalysisProto.toJSON(message.dataframe_analysis);
    }
    if (message.file_artifact !== undefined) {
      obj.file_artifact = FileArtifactProto.toJSON(message.file_artifact);
    }
    if (message.workflow_run !== undefined) {
      obj.workflow_run = WorkflowRunProto.toJSON(message.workflow_run);
    }
    if (message.workflow_run_search !== undefined) {
      obj.workflow_run_search = WorkflowRunSearchProto.toJSON(message.workflow_run_search);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArtifactProto>, I>>(base?: I): ArtifactProto {
    return ArtifactProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArtifactProto>, I>>(object: I): ArtifactProto {
    const message = createBaseArtifactProto();
    message.artifact_type = object.artifact_type ?? undefined;
    message.kg_observation = (object.kg_observation !== undefined && object.kg_observation !== null)
      ? KGObservationProto.fromPartial(object.kg_observation)
      : undefined;
    message.kg_dataframe = (object.kg_dataframe !== undefined && object.kg_dataframe !== null)
      ? KGDataFrameProto.fromPartial(object.kg_dataframe)
      : undefined;
    message.scenario = (object.scenario !== undefined && object.scenario !== null)
      ? ScenarioAnalysis.fromPartial(object.scenario)
      : undefined;
    message.analyst_job_run = (object.analyst_job_run !== undefined && object.analyst_job_run !== null)
      ? AnalystJobRunProto.fromPartial(object.analyst_job_run)
      : undefined;
    message.scenario_job = (object.scenario_job !== undefined && object.scenario_job !== null)
      ? ScheduledJobProto.fromPartial(object.scenario_job)
      : undefined;
    message.tool_type = object.tool_type ?? undefined;
    message.analysis_output = (object.analysis_output !== undefined && object.analysis_output !== null)
      ? AnalysisOutputProto.fromPartial(object.analysis_output)
      : undefined;
    message.chat_id = object.chat_id ?? undefined;
    message.dataframe_analysis = (object.dataframe_analysis !== undefined && object.dataframe_analysis !== null)
      ? DataFrameAnalysisProto.fromPartial(object.dataframe_analysis)
      : undefined;
    message.file_artifact = (object.file_artifact !== undefined && object.file_artifact !== null)
      ? FileArtifactProto.fromPartial(object.file_artifact)
      : undefined;
    message.workflow_run = (object.workflow_run !== undefined && object.workflow_run !== null)
      ? WorkflowRunProto.fromPartial(object.workflow_run)
      : undefined;
    message.workflow_run_search = (object.workflow_run_search !== undefined && object.workflow_run_search !== null)
      ? WorkflowRunSearchProto.fromPartial(object.workflow_run_search)
      : undefined;
    return message;
  },
};

function createBaseChatMessageProto(): ChatMessageProto {
  return {
    message_type: undefined,
    content: undefined,
    langgraph_message_json_list: [],
    artifacts: [],
    response_message: undefined,
    ls_trace_url: undefined,
    id: undefined,
    timestamp_ms: undefined,
    execution_steps: [],
  };
}

export const ChatMessageProto: MessageFns<ChatMessageProto> = {
  encode(message: ChatMessageProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message_type !== undefined) {
      writer.uint32(8).int32(message.message_type);
    }
    if (message.content !== undefined) {
      writer.uint32(18).string(message.content);
    }
    for (const v of message.langgraph_message_json_list) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.artifacts) {
      ArtifactProto.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.response_message !== undefined) {
      ResponseMessageProto.encode(message.response_message, writer.uint32(42).fork()).join();
    }
    if (message.ls_trace_url !== undefined) {
      writer.uint32(50).string(message.ls_trace_url);
    }
    if (message.id !== undefined) {
      writer.uint32(58).string(message.id);
    }
    if (message.timestamp_ms !== undefined) {
      writer.uint32(64).int64(message.timestamp_ms);
    }
    for (const v of message.execution_steps) {
      ExecutionStepProto.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMessageProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMessageProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.message_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.langgraph_message_json_list.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.artifacts.push(ArtifactProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.response_message = ResponseMessageProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ls_trace_url = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.timestamp_ms = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.execution_steps.push(ExecutionStepProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatMessageProto {
    return {
      message_type: isSet(object.message_type) ? chatMessageTypeFromJSON(object.message_type) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
      langgraph_message_json_list: globalThis.Array.isArray(object?.langgraph_message_json_list)
        ? object.langgraph_message_json_list.map((e: any) => globalThis.String(e))
        : [],
      artifacts: globalThis.Array.isArray(object?.artifacts)
        ? object.artifacts.map((e: any) => ArtifactProto.fromJSON(e))
        : [],
      response_message: isSet(object.response_message)
        ? ResponseMessageProto.fromJSON(object.response_message)
        : undefined,
      ls_trace_url: isSet(object.ls_trace_url) ? globalThis.String(object.ls_trace_url) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      timestamp_ms: isSet(object.timestamp_ms) ? globalThis.Number(object.timestamp_ms) : undefined,
      execution_steps: globalThis.Array.isArray(object?.execution_steps)
        ? object.execution_steps.map((e: any) => ExecutionStepProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChatMessageProto): unknown {
    const obj: any = {};
    if (message.message_type !== undefined) {
      obj.message_type = chatMessageTypeToJSON(message.message_type);
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    if (message.langgraph_message_json_list?.length) {
      obj.langgraph_message_json_list = message.langgraph_message_json_list;
    }
    if (message.artifacts?.length) {
      obj.artifacts = message.artifacts.map((e) => ArtifactProto.toJSON(e));
    }
    if (message.response_message !== undefined) {
      obj.response_message = ResponseMessageProto.toJSON(message.response_message);
    }
    if (message.ls_trace_url !== undefined) {
      obj.ls_trace_url = message.ls_trace_url;
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.timestamp_ms !== undefined) {
      obj.timestamp_ms = Math.round(message.timestamp_ms);
    }
    if (message.execution_steps?.length) {
      obj.execution_steps = message.execution_steps.map((e) => ExecutionStepProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatMessageProto>, I>>(base?: I): ChatMessageProto {
    return ChatMessageProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatMessageProto>, I>>(object: I): ChatMessageProto {
    const message = createBaseChatMessageProto();
    message.message_type = object.message_type ?? undefined;
    message.content = object.content ?? undefined;
    message.langgraph_message_json_list = object.langgraph_message_json_list?.map((e) => e) || [];
    message.artifacts = object.artifacts?.map((e) => ArtifactProto.fromPartial(e)) || [];
    message.response_message = (object.response_message !== undefined && object.response_message !== null)
      ? ResponseMessageProto.fromPartial(object.response_message)
      : undefined;
    message.ls_trace_url = object.ls_trace_url ?? undefined;
    message.id = object.id ?? undefined;
    message.timestamp_ms = object.timestamp_ms ?? undefined;
    message.execution_steps = object.execution_steps?.map((e) => ExecutionStepProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAgentInputProto(): AgentInputProto {
  return {
    trees: [],
    plans: [],
    custom_agents: [],
    analyst: undefined,
    scheduled_job: undefined,
    override_jinja_variables: undefined,
    scenario_jobs: [],
  };
}

export const AgentInputProto: MessageFns<AgentInputProto> = {
  encode(message: AgentInputProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.trees) {
      AnalysisTreeProto.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.plans) {
      AnalysisPlanProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.custom_agents) {
      CustomAgentProto.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.analyst !== undefined) {
      AnalystProto.encode(message.analyst, writer.uint32(34).fork()).join();
    }
    if (message.scheduled_job !== undefined) {
      ScheduledJobProto.encode(message.scheduled_job, writer.uint32(42).fork()).join();
    }
    if (message.override_jinja_variables !== undefined) {
      AgentInputProto_OverrideVariables.encode(message.override_jinja_variables, writer.uint32(50).fork()).join();
    }
    for (const v of message.scenario_jobs) {
      ScheduledJobProto.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentInputProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentInputProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trees.push(AnalysisTreeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plans.push(AnalysisPlanProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.custom_agents.push(CustomAgentProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.analyst = AnalystProto.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.scheduled_job = ScheduledJobProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.override_jinja_variables = AgentInputProto_OverrideVariables.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.scenario_jobs.push(ScheduledJobProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentInputProto {
    return {
      trees: globalThis.Array.isArray(object?.trees) ? object.trees.map((e: any) => AnalysisTreeProto.fromJSON(e)) : [],
      plans: globalThis.Array.isArray(object?.plans) ? object.plans.map((e: any) => AnalysisPlanProto.fromJSON(e)) : [],
      custom_agents: globalThis.Array.isArray(object?.custom_agents)
        ? object.custom_agents.map((e: any) => CustomAgentProto.fromJSON(e))
        : [],
      analyst: isSet(object.analyst) ? AnalystProto.fromJSON(object.analyst) : undefined,
      scheduled_job: isSet(object.scheduled_job) ? ScheduledJobProto.fromJSON(object.scheduled_job) : undefined,
      override_jinja_variables: isSet(object.override_jinja_variables)
        ? AgentInputProto_OverrideVariables.fromJSON(object.override_jinja_variables)
        : undefined,
      scenario_jobs: globalThis.Array.isArray(object?.scenario_jobs)
        ? object.scenario_jobs.map((e: any) => ScheduledJobProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AgentInputProto): unknown {
    const obj: any = {};
    if (message.trees?.length) {
      obj.trees = message.trees.map((e) => AnalysisTreeProto.toJSON(e));
    }
    if (message.plans?.length) {
      obj.plans = message.plans.map((e) => AnalysisPlanProto.toJSON(e));
    }
    if (message.custom_agents?.length) {
      obj.custom_agents = message.custom_agents.map((e) => CustomAgentProto.toJSON(e));
    }
    if (message.analyst !== undefined) {
      obj.analyst = AnalystProto.toJSON(message.analyst);
    }
    if (message.scheduled_job !== undefined) {
      obj.scheduled_job = ScheduledJobProto.toJSON(message.scheduled_job);
    }
    if (message.override_jinja_variables !== undefined) {
      obj.override_jinja_variables = AgentInputProto_OverrideVariables.toJSON(message.override_jinja_variables);
    }
    if (message.scenario_jobs?.length) {
      obj.scenario_jobs = message.scenario_jobs.map((e) => ScheduledJobProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentInputProto>, I>>(base?: I): AgentInputProto {
    return AgentInputProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentInputProto>, I>>(object: I): AgentInputProto {
    const message = createBaseAgentInputProto();
    message.trees = object.trees?.map((e) => AnalysisTreeProto.fromPartial(e)) || [];
    message.plans = object.plans?.map((e) => AnalysisPlanProto.fromPartial(e)) || [];
    message.custom_agents = object.custom_agents?.map((e) => CustomAgentProto.fromPartial(e)) || [];
    message.analyst = (object.analyst !== undefined && object.analyst !== null)
      ? AnalystProto.fromPartial(object.analyst)
      : undefined;
    message.scheduled_job = (object.scheduled_job !== undefined && object.scheduled_job !== null)
      ? ScheduledJobProto.fromPartial(object.scheduled_job)
      : undefined;
    message.override_jinja_variables =
      (object.override_jinja_variables !== undefined && object.override_jinja_variables !== null)
        ? AgentInputProto_OverrideVariables.fromPartial(object.override_jinja_variables)
        : undefined;
    message.scenario_jobs = object.scenario_jobs?.map((e) => ScheduledJobProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAgentInputProto_OverrideVariables(): AgentInputProto_OverrideVariables {
  return { today_date: undefined, company_name: undefined, week_start_day: undefined, quarter_start_month: undefined };
}

export const AgentInputProto_OverrideVariables: MessageFns<AgentInputProto_OverrideVariables> = {
  encode(message: AgentInputProto_OverrideVariables, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.today_date !== undefined) {
      writer.uint32(10).string(message.today_date);
    }
    if (message.company_name !== undefined) {
      writer.uint32(18).string(message.company_name);
    }
    if (message.week_start_day !== undefined) {
      writer.uint32(26).string(message.week_start_day);
    }
    if (message.quarter_start_month !== undefined) {
      writer.uint32(34).string(message.quarter_start_month);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentInputProto_OverrideVariables {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentInputProto_OverrideVariables();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.today_date = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.company_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.week_start_day = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.quarter_start_month = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentInputProto_OverrideVariables {
    return {
      today_date: isSet(object.today_date) ? globalThis.String(object.today_date) : undefined,
      company_name: isSet(object.company_name) ? globalThis.String(object.company_name) : undefined,
      week_start_day: isSet(object.week_start_day) ? globalThis.String(object.week_start_day) : undefined,
      quarter_start_month: isSet(object.quarter_start_month)
        ? globalThis.String(object.quarter_start_month)
        : undefined,
    };
  },

  toJSON(message: AgentInputProto_OverrideVariables): unknown {
    const obj: any = {};
    if (message.today_date !== undefined) {
      obj.today_date = message.today_date;
    }
    if (message.company_name !== undefined) {
      obj.company_name = message.company_name;
    }
    if (message.week_start_day !== undefined) {
      obj.week_start_day = message.week_start_day;
    }
    if (message.quarter_start_month !== undefined) {
      obj.quarter_start_month = message.quarter_start_month;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentInputProto_OverrideVariables>, I>>(
    base?: I,
  ): AgentInputProto_OverrideVariables {
    return AgentInputProto_OverrideVariables.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentInputProto_OverrideVariables>, I>>(
    object: I,
  ): AgentInputProto_OverrideVariables {
    const message = createBaseAgentInputProto_OverrideVariables();
    message.today_date = object.today_date ?? undefined;
    message.company_name = object.company_name ?? undefined;
    message.week_start_day = object.week_start_day ?? undefined;
    message.quarter_start_month = object.quarter_start_month ?? undefined;
    return message;
  },
};

function createBaseChatResponse(): ChatResponse {
  return { session_header: undefined, messages: [], status: undefined, analyst_id: undefined };
}

export const ChatResponse: MessageFns<ChatResponse> = {
  encode(message: ChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.session_header !== undefined) {
      DarwinHeader.encode(message.session_header, writer.uint32(10).fork()).join();
    }
    for (const v of message.messages) {
      ChatMessageProto.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.status !== undefined) {
      writer.uint32(24).int32(message.status);
    }
    if (message.analyst_id !== undefined) {
      writer.uint32(34).string(message.analyst_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.session_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messages.push(ChatMessageProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.analyst_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatResponse {
    return {
      session_header: isSet(object.session_header) ? DarwinHeader.fromJSON(object.session_header) : undefined,
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => ChatMessageProto.fromJSON(e))
        : [],
      status: isSet(object.status) ? executionStatusTypeFromJSON(object.status) : undefined,
      analyst_id: isSet(object.analyst_id) ? globalThis.String(object.analyst_id) : undefined,
    };
  },

  toJSON(message: ChatResponse): unknown {
    const obj: any = {};
    if (message.session_header !== undefined) {
      obj.session_header = DarwinHeader.toJSON(message.session_header);
    }
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => ChatMessageProto.toJSON(e));
    }
    if (message.status !== undefined) {
      obj.status = executionStatusTypeToJSON(message.status);
    }
    if (message.analyst_id !== undefined) {
      obj.analyst_id = message.analyst_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatResponse>, I>>(base?: I): ChatResponse {
    return ChatResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatResponse>, I>>(object: I): ChatResponse {
    const message = createBaseChatResponse();
    message.session_header = (object.session_header !== undefined && object.session_header !== null)
      ? DarwinHeader.fromPartial(object.session_header)
      : undefined;
    message.messages = object.messages?.map((e) => ChatMessageProto.fromPartial(e)) || [];
    message.status = object.status ?? undefined;
    message.analyst_id = object.analyst_id ?? undefined;
    return message;
  },
};

function createBaseChatContext(): ChatContext {
  return { agent_type: undefined, agent_header: undefined, prompt_header: undefined, agent_input: undefined };
}

export const ChatContext: MessageFns<ChatContext> = {
  encode(message: ChatContext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.agent_type !== undefined) {
      writer.uint32(8).int32(message.agent_type);
    }
    if (message.agent_header !== undefined) {
      DarwinHeader.encode(message.agent_header, writer.uint32(18).fork()).join();
    }
    if (message.prompt_header !== undefined) {
      DarwinHeader.encode(message.prompt_header, writer.uint32(26).fork()).join();
    }
    if (message.agent_input !== undefined) {
      AgentInputProto.encode(message.agent_input, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatContext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.agent_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.agent_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.agent_input = AgentInputProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatContext {
    return {
      agent_type: isSet(object.agent_type) ? darwinAgentTypeFromJSON(object.agent_type) : undefined,
      agent_header: isSet(object.agent_header) ? DarwinHeader.fromJSON(object.agent_header) : undefined,
      prompt_header: isSet(object.prompt_header) ? DarwinHeader.fromJSON(object.prompt_header) : undefined,
      agent_input: isSet(object.agent_input) ? AgentInputProto.fromJSON(object.agent_input) : undefined,
    };
  },

  toJSON(message: ChatContext): unknown {
    const obj: any = {};
    if (message.agent_type !== undefined) {
      obj.agent_type = darwinAgentTypeToJSON(message.agent_type);
    }
    if (message.agent_header !== undefined) {
      obj.agent_header = DarwinHeader.toJSON(message.agent_header);
    }
    if (message.prompt_header !== undefined) {
      obj.prompt_header = DarwinHeader.toJSON(message.prompt_header);
    }
    if (message.agent_input !== undefined) {
      obj.agent_input = AgentInputProto.toJSON(message.agent_input);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatContext>, I>>(base?: I): ChatContext {
    return ChatContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatContext>, I>>(object: I): ChatContext {
    const message = createBaseChatContext();
    message.agent_type = object.agent_type ?? undefined;
    message.agent_header = (object.agent_header !== undefined && object.agent_header !== null)
      ? DarwinHeader.fromPartial(object.agent_header)
      : undefined;
    message.prompt_header = (object.prompt_header !== undefined && object.prompt_header !== null)
      ? DarwinHeader.fromPartial(object.prompt_header)
      : undefined;
    message.agent_input = (object.agent_input !== undefined && object.agent_input !== null)
      ? AgentInputProto.fromPartial(object.agent_input)
      : undefined;
    return message;
  },
};

function createBaseUploadedFile(): UploadedFile {
  return { file_bytes: undefined, file_name: undefined };
}

export const UploadedFile: MessageFns<UploadedFile> = {
  encode(message: UploadedFile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.file_bytes !== undefined) {
      writer.uint32(10).bytes(message.file_bytes);
    }
    if (message.file_name !== undefined) {
      writer.uint32(18).string(message.file_name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadedFile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadedFile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.file_bytes = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.file_name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadedFile {
    return {
      file_bytes: isSet(object.file_bytes) ? bytesFromBase64(object.file_bytes) : undefined,
      file_name: isSet(object.file_name) ? globalThis.String(object.file_name) : undefined,
    };
  },

  toJSON(message: UploadedFile): unknown {
    const obj: any = {};
    if (message.file_bytes !== undefined) {
      obj.file_bytes = base64FromBytes(message.file_bytes);
    }
    if (message.file_name !== undefined) {
      obj.file_name = message.file_name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadedFile>, I>>(base?: I): UploadedFile {
    return UploadedFile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadedFile>, I>>(object: I): UploadedFile {
    const message = createBaseUploadedFile();
    message.file_bytes = object.file_bytes ?? undefined;
    message.file_name = object.file_name ?? undefined;
    return message;
  },
};

function createBaseParseTableRequest(): ParseTableRequest {
  return { raw_text: undefined };
}

export const ParseTableRequest: MessageFns<ParseTableRequest> = {
  encode(message: ParseTableRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.raw_text !== undefined) {
      writer.uint32(10).string(message.raw_text);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParseTableRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParseTableRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.raw_text = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParseTableRequest {
    return { raw_text: isSet(object.raw_text) ? globalThis.String(object.raw_text) : undefined };
  },

  toJSON(message: ParseTableRequest): unknown {
    const obj: any = {};
    if (message.raw_text !== undefined) {
      obj.raw_text = message.raw_text;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParseTableRequest>, I>>(base?: I): ParseTableRequest {
    return ParseTableRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParseTableRequest>, I>>(object: I): ParseTableRequest {
    const message = createBaseParseTableRequest();
    message.raw_text = object.raw_text ?? undefined;
    return message;
  },
};

function createBaseParsedTablePreviewRow(): ParsedTablePreviewRow {
  return { cells: [] };
}

export const ParsedTablePreviewRow: MessageFns<ParsedTablePreviewRow> = {
  encode(message: ParsedTablePreviewRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.cells) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParsedTablePreviewRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParsedTablePreviewRow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cells.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParsedTablePreviewRow {
    return { cells: globalThis.Array.isArray(object?.cells) ? object.cells.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: ParsedTablePreviewRow): unknown {
    const obj: any = {};
    if (message.cells?.length) {
      obj.cells = message.cells;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParsedTablePreviewRow>, I>>(base?: I): ParsedTablePreviewRow {
    return ParsedTablePreviewRow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParsedTablePreviewRow>, I>>(object: I): ParsedTablePreviewRow {
    const message = createBaseParsedTablePreviewRow();
    message.cells = object.cells?.map((e) => e) || [];
    return message;
  },
};

function createBaseParseTableResponse(): ParseTableResponse {
  return {
    success: undefined,
    error_message: undefined,
    headers: [],
    column_types: [],
    row_count: undefined,
    preview_rows: [],
    csv_string: undefined,
  };
}

export const ParseTableResponse: MessageFns<ParseTableResponse> = {
  encode(message: ParseTableResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== undefined) {
      writer.uint32(8).bool(message.success);
    }
    if (message.error_message !== undefined) {
      writer.uint32(18).string(message.error_message);
    }
    for (const v of message.headers) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.column_types) {
      writer.uint32(34).string(v!);
    }
    if (message.row_count !== undefined) {
      writer.uint32(40).int32(message.row_count);
    }
    for (const v of message.preview_rows) {
      ParsedTablePreviewRow.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.csv_string !== undefined) {
      writer.uint32(58).string(message.csv_string);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParseTableResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParseTableResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error_message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.headers.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.column_types.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.row_count = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.preview_rows.push(ParsedTablePreviewRow.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.csv_string = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParseTableResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : undefined,
      error_message: isSet(object.error_message) ? globalThis.String(object.error_message) : undefined,
      headers: globalThis.Array.isArray(object?.headers) ? object.headers.map((e: any) => globalThis.String(e)) : [],
      column_types: globalThis.Array.isArray(object?.column_types)
        ? object.column_types.map((e: any) => globalThis.String(e))
        : [],
      row_count: isSet(object.row_count) ? globalThis.Number(object.row_count) : undefined,
      preview_rows: globalThis.Array.isArray(object?.preview_rows)
        ? object.preview_rows.map((e: any) => ParsedTablePreviewRow.fromJSON(e))
        : [],
      csv_string: isSet(object.csv_string) ? globalThis.String(object.csv_string) : undefined,
    };
  },

  toJSON(message: ParseTableResponse): unknown {
    const obj: any = {};
    if (message.success !== undefined) {
      obj.success = message.success;
    }
    if (message.error_message !== undefined) {
      obj.error_message = message.error_message;
    }
    if (message.headers?.length) {
      obj.headers = message.headers;
    }
    if (message.column_types?.length) {
      obj.column_types = message.column_types;
    }
    if (message.row_count !== undefined) {
      obj.row_count = Math.round(message.row_count);
    }
    if (message.preview_rows?.length) {
      obj.preview_rows = message.preview_rows.map((e) => ParsedTablePreviewRow.toJSON(e));
    }
    if (message.csv_string !== undefined) {
      obj.csv_string = message.csv_string;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParseTableResponse>, I>>(base?: I): ParseTableResponse {
    return ParseTableResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParseTableResponse>, I>>(object: I): ParseTableResponse {
    const message = createBaseParseTableResponse();
    message.success = object.success ?? undefined;
    message.error_message = object.error_message ?? undefined;
    message.headers = object.headers?.map((e) => e) || [];
    message.column_types = object.column_types?.map((e) => e) || [];
    message.row_count = object.row_count ?? undefined;
    message.preview_rows = object.preview_rows?.map((e) => ParsedTablePreviewRow.fromPartial(e)) || [];
    message.csv_string = object.csv_string ?? undefined;
    return message;
  },
};

function createBaseChatRequest(): ChatRequest {
  return {
    session_header: undefined,
    chat_context: undefined,
    message: undefined,
    is_save: undefined,
    stream_response: undefined,
    uploaded_files: [],
  };
}

export const ChatRequest: MessageFns<ChatRequest> = {
  encode(message: ChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.session_header !== undefined) {
      DarwinHeader.encode(message.session_header, writer.uint32(10).fork()).join();
    }
    if (message.chat_context !== undefined) {
      ChatContext.encode(message.chat_context, writer.uint32(18).fork()).join();
    }
    if (message.message !== undefined) {
      writer.uint32(26).string(message.message);
    }
    if (message.is_save !== undefined) {
      writer.uint32(32).bool(message.is_save);
    }
    if (message.stream_response !== undefined) {
      writer.uint32(48).bool(message.stream_response);
    }
    for (const v of message.uploaded_files) {
      UploadedFile.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.session_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chat_context = ChatContext.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_save = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.stream_response = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.uploaded_files.push(UploadedFile.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatRequest {
    return {
      session_header: isSet(object.session_header) ? DarwinHeader.fromJSON(object.session_header) : undefined,
      chat_context: isSet(object.chat_context) ? ChatContext.fromJSON(object.chat_context) : undefined,
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
      is_save: isSet(object.is_save) ? globalThis.Boolean(object.is_save) : undefined,
      stream_response: isSet(object.stream_response) ? globalThis.Boolean(object.stream_response) : undefined,
      uploaded_files: globalThis.Array.isArray(object?.uploaded_files)
        ? object.uploaded_files.map((e: any) => UploadedFile.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChatRequest): unknown {
    const obj: any = {};
    if (message.session_header !== undefined) {
      obj.session_header = DarwinHeader.toJSON(message.session_header);
    }
    if (message.chat_context !== undefined) {
      obj.chat_context = ChatContext.toJSON(message.chat_context);
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.is_save !== undefined) {
      obj.is_save = message.is_save;
    }
    if (message.stream_response !== undefined) {
      obj.stream_response = message.stream_response;
    }
    if (message.uploaded_files?.length) {
      obj.uploaded_files = message.uploaded_files.map((e) => UploadedFile.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatRequest>, I>>(base?: I): ChatRequest {
    return ChatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatRequest>, I>>(object: I): ChatRequest {
    const message = createBaseChatRequest();
    message.session_header = (object.session_header !== undefined && object.session_header !== null)
      ? DarwinHeader.fromPartial(object.session_header)
      : undefined;
    message.chat_context = (object.chat_context !== undefined && object.chat_context !== null)
      ? ChatContext.fromPartial(object.chat_context)
      : undefined;
    message.message = object.message ?? undefined;
    message.is_save = object.is_save ?? undefined;
    message.stream_response = object.stream_response ?? undefined;
    message.uploaded_files = object.uploaded_files?.map((e) => UploadedFile.fromPartial(e)) || [];
    return message;
  },
};

function createBaseExecutionStepProto(): ExecutionStepProto {
  return {
    status: undefined,
    tool_type: undefined,
    timestamp_ms: undefined,
    artifacts: [],
    step_labels: [],
    error: undefined,
    reasoning_summary: undefined,
  };
}

export const ExecutionStepProto: MessageFns<ExecutionStepProto> = {
  encode(message: ExecutionStepProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== undefined) {
      writer.uint32(8).int32(message.status);
    }
    if (message.tool_type !== undefined) {
      writer.uint32(16).int32(message.tool_type);
    }
    if (message.timestamp_ms !== undefined) {
      writer.uint32(24).int64(message.timestamp_ms);
    }
    for (const v of message.artifacts) {
      ArtifactProto.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.step_labels) {
      writer.uint32(42).string(v!);
    }
    if (message.error !== undefined) {
      writer.uint32(50).string(message.error);
    }
    if (message.reasoning_summary !== undefined) {
      writer.uint32(58).string(message.reasoning_summary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionStepProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExecutionStepProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tool_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.timestamp_ms = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.artifacts.push(ArtifactProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.step_labels.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.error = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.reasoning_summary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExecutionStepProto {
    return {
      status: isSet(object.status) ? executionStatusTypeFromJSON(object.status) : undefined,
      tool_type: isSet(object.tool_type) ? darwinToolTypeFromJSON(object.tool_type) : undefined,
      timestamp_ms: isSet(object.timestamp_ms) ? globalThis.Number(object.timestamp_ms) : undefined,
      artifacts: globalThis.Array.isArray(object?.artifacts)
        ? object.artifacts.map((e: any) => ArtifactProto.fromJSON(e))
        : [],
      step_labels: globalThis.Array.isArray(object?.step_labels)
        ? object.step_labels.map((e: any) => globalThis.String(e))
        : [],
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
      reasoning_summary: isSet(object.reasoning_summary) ? globalThis.String(object.reasoning_summary) : undefined,
    };
  },

  toJSON(message: ExecutionStepProto): unknown {
    const obj: any = {};
    if (message.status !== undefined) {
      obj.status = executionStatusTypeToJSON(message.status);
    }
    if (message.tool_type !== undefined) {
      obj.tool_type = darwinToolTypeToJSON(message.tool_type);
    }
    if (message.timestamp_ms !== undefined) {
      obj.timestamp_ms = Math.round(message.timestamp_ms);
    }
    if (message.artifacts?.length) {
      obj.artifacts = message.artifacts.map((e) => ArtifactProto.toJSON(e));
    }
    if (message.step_labels?.length) {
      obj.step_labels = message.step_labels;
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    if (message.reasoning_summary !== undefined) {
      obj.reasoning_summary = message.reasoning_summary;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecutionStepProto>, I>>(base?: I): ExecutionStepProto {
    return ExecutionStepProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionStepProto>, I>>(object: I): ExecutionStepProto {
    const message = createBaseExecutionStepProto();
    message.status = object.status ?? undefined;
    message.tool_type = object.tool_type ?? undefined;
    message.timestamp_ms = object.timestamp_ms ?? undefined;
    message.artifacts = object.artifacts?.map((e) => ArtifactProto.fromPartial(e)) || [];
    message.step_labels = object.step_labels?.map((e) => e) || [];
    message.error = object.error ?? undefined;
    message.reasoning_summary = object.reasoning_summary ?? undefined;
    return message;
  },
};

function createBaseStreamResponseProto(): StreamResponseProto {
  return { type: undefined, text: undefined, index: undefined, step: undefined };
}

export const StreamResponseProto: MessageFns<StreamResponseProto> = {
  encode(message: StreamResponseProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.text !== undefined) {
      writer.uint32(18).string(message.text);
    }
    if (message.index !== undefined) {
      writer.uint32(24).int32(message.index);
    }
    if (message.step !== undefined) {
      ExecutionStepProto.encode(message.step, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StreamResponseProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreamResponseProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.index = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.step = ExecutionStepProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StreamResponseProto {
    return {
      type: isSet(object.type) ? streamResponseProto_StremResponseTypeFromJSON(object.type) : undefined,
      text: isSet(object.text) ? globalThis.String(object.text) : undefined,
      index: isSet(object.index) ? globalThis.Number(object.index) : undefined,
      step: isSet(object.step) ? ExecutionStepProto.fromJSON(object.step) : undefined,
    };
  },

  toJSON(message: StreamResponseProto): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = streamResponseProto_StremResponseTypeToJSON(message.type);
    }
    if (message.text !== undefined) {
      obj.text = message.text;
    }
    if (message.index !== undefined) {
      obj.index = Math.round(message.index);
    }
    if (message.step !== undefined) {
      obj.step = ExecutionStepProto.toJSON(message.step);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StreamResponseProto>, I>>(base?: I): StreamResponseProto {
    return StreamResponseProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StreamResponseProto>, I>>(object: I): StreamResponseProto {
    const message = createBaseStreamResponseProto();
    message.type = object.type ?? undefined;
    message.text = object.text ?? undefined;
    message.index = object.index ?? undefined;
    message.step = (object.step !== undefined && object.step !== null)
      ? ExecutionStepProto.fromPartial(object.step)
      : undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
